import { Pdf } from '~components/common/forms/Pdf.js'

export const My_pdf = class {
  constructor(default_opt) {
    this.pdf = new Pdf();
    this.resourceId = this.pdf.preserveId();
    this.imgs = {};
    this.pages = [];
    this.default = {
      color: '0 0 0',
      font_size: 16,
      page_width: 841,
      page_height: 1189,
      page_padding_x: 0,
      page_padding_y: 0,
    };
    if(default_opt) {
      Object.entries(default_opt).forEach(key_val => this.setDefault(...key_val));
    }
  }
  setDefault(type, val) {
    this.default[type] = val;
  }
  getDataUrl() {
    this.drawPages();
    this.createResource();
    let catlogId = this.pdf.preserveId();
    this.pdf.addObject({
        Type: '/Catalog',
        Pages: `${this.pagesId} 0 R`,
    }, false, catlogId);
    return this.pdf.toDataUrl(catlogId);
  }
  drawPages() {
    if(!this.pages.length) this.appendPage();
    this.pagesId = this.pdf.preserveId();
    let kids = this.pages.map(page => {
      let contentId = this.pdf.preserveId();
      this.pdf.addObject({
          Type: '/Page',
          Parent: `${this.pagesId} 0 R`,
          Contents: `[${contentId} 0 R]`,
          MediaBox: `[0 0 ${page.width} ${page.height}]` //A4 大小
      }, false, page.id);
      this.pdf.addObject({}, page.drawPageContents(), contentId);
      return `${page.id} 0 R`;
    });
    this.pdf.addObject({
        Type: '/Pages',
        Kids: `[${kids.join(' ')}]`,
        Resources: `${this.resourceId} 0 R`,
        Count: this.pages.length,
    }, false, this.pagesId);
  }
  createResource() {
    let XObject = Object.entries(this.imgs).map(([imgName, img]) => {
      this.pdf.addObject({
          Type: '/XObject',
          Subtype: '/Image',
          Width: img.width,
          Height: img.height,
          ColorSpace: '/DeviceRGB',
          Filter: '[/ASCII85Decode /DCTDecode]'
      }, img.base85 + '~>', img.id);
      return `[/${imgName} ${img.id} 0 R]`;
    });
    this.pdf.addObject({
        XObject: `<< ${XObject.join(' ')} >>`
    }, false, this.resourceId);
  }
  appendPage(contents, width, height) {
    this.pages.push(
      new My_pdf_page(this, contents, width, height)
    );
  }
  appendPageContent(index, content) {
    if(!this.pages[index]) return;
    this.pages[index].contents.push(content);
  }
  appendImg(name, base64, width, height) {
    this.imgs[name] = {
      id: this.pdf.preserveId(),
      base85: base64ToBase85(base64.split('base64,')[1]),
      width: width,
      height: height,
    };
    function base64ToBase85(base64) {
        let arr = Array.from(atob(base64), x => x.codePointAt());
        let padN = arr.length % 4 > 0 ? 4 - arr.length % 4 : 0;
        while (padN-- > 0) {
            arr.push(0);
        }
        //每4個一組
        let result = '';
        for (let i = 0, n = arr.length; i + 3 < n; i += 4) {
            let H = (arr[i] << 8 | arr[i + 1]);
            let L = (arr[i + 2] << 8 | arr[i + 3]);
            let tmp = '';
            for (let j = 0; j < 5; ++j) {
                let t = (H % 85 << 16 | L % 85);
                let r = t % 85; //對 85 取餘數
                //除 85
                H = (H - H % 85) / 85;
                L = (L - L % 85) / 85 + (t - t % 85) / 85;
                H += L >>> 16;
                L&=0xffff;
                tmp = String.fromCodePoint(33 + r) + tmp;
            }
            result += tmp;
        }
        return result;
    }
  }
  getImg(imgName) {
    return this.imgs[imgName];
  }
}

class My_pdf_page {
  constructor(parent_pdf, contents, width, height, padding_x, padding_y) {
    this.getImg = (imgName) => parent_pdf.getImg(imgName);
    this.default = Object.assign({}, parent_pdf.default);
    this.id = parent_pdf.pdf.preserveId();
    this.contents = contents || [];
    this.width = width || this.default.page_width;
    this.height = height || this.default.page_height;
    this.padding_x = padding_x || this.default.page_padding_x;
    this.padding_y = padding_y || this.default.page_padding_y;
  }
  convertReverseY(y, h) {
    return this.height - (h || 0) - y - this.padding_y;
  }
  convertPercentage(type, percentage_str) {
    if(typeof percentage_str == 'number') return percentage_str;
    let percentage = parseFloat(percentage_str) / 100;
    if(type == 'w') {
      return (this.width - this.padding_x * 2) * percentage;
    }
    else {
      return (this.height - this.padding_y * 2) * percentage;
    }
  }
  convertX(x) {
    if(!x) x = 0;
    if(typeof x == 'number') return x + this.padding_x;
    return this.convertPercentage('w', x) + this.padding_x;
  }
  convertY(y, h) {
    if(!y) y = 0;
    if(typeof y == 'number') return this.convertReverseY(y, h);
    return this.convertReverseY(this.convertPercentage('h', y), h);
  }
  convertW(w) {
    if(!w) w = 0;
    if(typeof w == 'number') return w;
    return this.convertPercentage('w', w);
  }
  convertH(h) {
    if(!h) h = 0;
    if(typeof h == 'number') return h;
    return this.convertPercentage('h', h);
  }
  drawPageContents() {
    return this.contents.map(cnt => {
      switch(cnt.type) {
        case 'img': return this.drawPageContent_img(cnt);
        case 're': return this.drawPageContent_re(cnt);
        case 'text': return this.drawPageContent_text(cnt);
      }
    }).filter(v => v).join('\n');
  }
  drawPageContent_img(cnt) {
    let targetImg = this.getImg(cnt.img);
    if(targetImg) {
      let x = this.convertX(cnt.x, targetImg.height);
      let y = this.convertY(cnt.y, targetImg.height);
      return `q ${targetImg.width} 0 0 ${targetImg.height} ${x} ${y} cm /${cnt.img} Do Q`;
    }
  }
  drawPageContent_re(cnt) {
    let w = this.convertW(cnt.w);
    let h = this.convertH(cnt.h);
    let x = this.convertX(cnt.x);
    let y = this.convertY(cnt.y, h);
    let color = cnt.color || (cnt.d_type == 'f' ? '1 1 1' : this.default.color);
    return `${color} rg\n${x} ${y} ${w} ${h} re ${cnt.d_type || 's'}`;
  }
  drawPageContent_text(cnt) {
    let {color, font_size, text} = cnt;
    if(!color) color = this.default.color;
    if(!font_size) font_size = this.default.font_size;
    let x = this.convertX(cnt.x);
    let y = this.convertY(cnt.y, font_size);
    return `${color} rg\nBT /Tm ${font_size} Tf ${x} ${y} TD (${text || 'none'}) Tj ET`;
  }
}

function getTestPng(f_color, s_color) {
  let cvs = document.createElement('canvas');
  cvs.width = 200;
  cvs.height = 200;
  let ctx = cvs.getContext('2d');
  ctx.fillStyle = f_color;
  ctx.fillRect(0, 0, 200, 200);
  ctx.beginPath();
  ctx.arc(100, 100, 50, 0, Math.PI * 2);
  ctx.strokeStyle = s_color;
  ctx.stroke();
  return cvs.toDataURL('image/jpeg', 1.0);
}